import React from "react";
import MarkFinishedSvg from '@/assets/icons/mark-finished.svg?react';

interface MarkFinishedIconProps {
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
  className?: string;
}

const MarkFinishedIcon: React.FC<MarkFinishedIconProps> = ({
  size = "md",
  color = "currentColor",
  className = "",
}) => {
  const sizeClasses = {
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-7 h-7",
  };

  return (
    <MarkFinishedSvg
      fill={color}
      className={`${sizeClasses[size]} ${className}`}
    />
  )
};

export default MarkFinishedIcon;